import React from 'react';

interface BasicInputProps {
    id: string;
    label: string;
    readOnly: boolean;
    helper: string;
    error: string;
    value: string;
    onChange: (arg0: string) => void;
}

export default function TextAreaInput({
  id, label, readOnly, helper, error, value, onChange,
}: BasicInputProps) {
  return (
    <div className="basic-input">
      <label htmlFor={id}>
        <p>{label}</p>
        <textarea
          id={id}
          readOnly={readOnly}
          className={`${readOnly ? 'readonly' : ''}`}
          value={value}
          onChange={(data) => onChange(data.target.value)}
        />
        {helper.length > 0
      && error.length === 0
      && !readOnly && (
        <span className="input-helper">{helper}</span>
        ) }
        {error.length > 0
        && !readOnly
      && (
      <span className="input-error">{error}</span>
      )}
      </label>
    </div>

  );
}
